import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseBapp = initializeApp({
  apiKey: "AIzaSyC4dv9ZewD5tD4ye_8VpB_pZRMNPhYvv2M",
  authDomain: "niroogenerator-b5999.firebaseapp.com",
  projectId: "niroogenerator-b5999",
  storageBucket: "niroogenerator-b5999.appspot.com",
  messagingSenderId: "228469019897",
  appId: "1:228469019897:web:9f90647aefe20a89cd7e28",
  measurementId: "G-XX9B1S05X3",
});

const messaging = getMessaging(firebaseBapp);

// Retrieve firebase messaging
messaging.onBackgroundMessage = (payload) => {};

export const checkFirebaseToken = async () => {
  let firebaseToken = localStorage.getItem("listenerId");
  if (!firebaseToken) {
    let token = await requestForToken();

    if (token) {
      localStorage.setItem("listenerId", token);
      return token;
    } else {
      console.log("cannot get firebase token!");
    }
  }
  return firebaseToken;
};

export const requestForToken = async () => {
  let data = await getToken(messaging, {
    vapidKey:
      "BGBYDjSTKIH2GE_IW_pLEAxq3ecB46YO1nghuxB_IlkRXZlethK4lojeGUVHzaEybpyZwPa1i93rG_YxrbXIdA0",
  });
  return data;
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      const receiveNotification = new CustomEvent("receiveNotification", {
        detail: { payload },
        bubbles: true,
        cancelable: true,
        composed: false,
      });
      window.dispatchEvent(receiveNotification);
      resolve(payload);
    });
  });
